import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PageviewIcon from '@mui/icons-material/Pageview';
import WorkIcon from '@mui/icons-material/Work';
import { Grid, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { FC } from 'react';
import { HiOutlineOfficeBuilding } from 'react-icons/hi';
import { IJob, ILocation } from 'wisestep-api';

import { timeSince } from '../../helper/DateOperations/DateOperations';
import { formatLocation } from '../../helper/LocationUtil/LocationUtil';
import WsColors from '../../WsColors';
import Item from '../Item/Item';
import WsButton from '../WsButton/WsButton';
import WsTypography, { WsTypoColors, WsTypoVariants } from '../WsTypography/WsTypography';

const GridItem = styled(Item)(() => ({
  padding: '2px 6px 2px 4px',
}));

const JobElement = styled(Paper)(() => ({
  borderRadius: 8,
  padding: 8,
  marginBottom: 16,
}));

interface IWsJobSelect {
  job: IJob;
  getSelectedJob(args: IJob): void;
}

const WsJobSelect: FC<IWsJobSelect> = ({ job, getSelectedJob }) => (
  <JobElement variant="outlined">
    <Grid container direction="row" spacing={0}>
      <Grid container item xs={10} direction="row" spacing={0}>
        <Grid item>
          <GridItem>
            <WorkIcon sx={{ color: WsColors.TheBlues500, fontSize: '24px', mt: '3px' }} />
          </GridItem>
        </Grid>
        <Grid item>
          <GridItem>
            <WsTypography variant={WsTypoVariants.SUB_TITLE}>{String(job.title)}</WsTypography>
          </GridItem>
        </Grid>
      </Grid>
      <Grid item xs={2} mt={1}>
        <WsButton size="small" onClick={() => getSelectedJob(job)}>
          Select
        </WsButton>
      </Grid>
    </Grid>
    <Grid container direction="row" spacing={0}>
      <Grid item>
        <GridItem>
          <PageviewIcon style={{ color: WsColors.GreyBlack, fontSize: '22px' }} />
        </GridItem>
      </Grid>
      <Grid item>
        <GridItem>
          <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.SECONDARY}>
            {String(job.jobCode)}
          </WsTypography>
        </GridItem>
      </Grid>
    </Grid>
    <Grid container direction="row" spacing={0}>
      <Grid item>
        <GridItem>
          <HiOutlineOfficeBuilding style={{ color: WsColors.GreyBlack, fontSize: '22px' }} />
        </GridItem>
      </Grid>
      <Grid item>
        <GridItem>
          <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.SECONDARY}>
            {String(job.companyName)}
          </WsTypography>
        </GridItem>
      </Grid>
    </Grid>
    <Grid container direction="row" spacing={0}>
      <Grid item>
        <GridItem>
          <LocationOnOutlinedIcon style={{ color: WsColors.GreyBlack, fontSize: '22px' }} />
        </GridItem>
      </Grid>
      <Grid item>
        <GridItem>
          {job.locations?.map((location: ILocation, index: number) => (
            <WsTypography key={index} variant={WsTypoVariants.BODY1} color={WsTypoColors.SECONDARY}>
              {formatLocation(location)}
            </WsTypography>
          ))}
        </GridItem>
      </Grid>
    </Grid>
    <Grid container direction="row" spacing={0}>
      <Grid item ml={1}>
        <GridItem>
          <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.SECONDARY}>
            {'Posted by ' + job.jobOwner + ' ' + String(timeSince(String(job.createdOn)))}
          </WsTypography>
        </GridItem>
      </Grid>
    </Grid>
  </JobElement>
);

export default WsJobSelect;
